export default function TSeriesService($http, appSettings) {

  'ngInject';

  var tSeriesEndpoint = appSettings.InReachApiEndpoint + '/tseries';

  return {

    getValidationSummary: function () {
      var endpoint = tSeriesEndpoint + '/report?type=validationsummary';

      return $http.get(endpoint);
    },
    getValidationDetail: function () {
      var endpoint = tSeriesEndpoint + '/report?type=ValidationDetail';

      return $http.get(endpoint);
    },
    getUtilizationSummary: function () {
      var endpoint = tSeriesEndpoint + '/report?type=UtilizationSummary';

      return $http.get(endpoint);
    },
    getUtilizationDetail: function () {
      var endpoint = tSeriesEndpoint + '/report?type=UtilizationDetail';

      return $http.get(endpoint);
    },
    getInventorySummary: function () {
      var endpoint = tSeriesEndpoint + '/report?type=InventorySummary';

      return $http.get(endpoint);
    },
    getInventoryDetail: function () {
      var endpoint = tSeriesEndpoint + '/report?type=InventoryDetail';

      return $http.get(endpoint);
    },
    getRecentFleetActivities: function (size) {
      var endpoint = tSeriesEndpoint + '/activity';
      if (size && parseInt(size, 10) > 0) endpoint += '?size=' + size;
      return $http.get(endpoint);
    }
  };
}